export default (value) => (value || '').substring(0, 2) || 'Aa';
